module.exports = __webpack_public_path__ + "static/media/not_found.fa5992b7.svg";